import React from "react";

export default function TFooter() {
  return (
    <>
      <footer className="py-4 bg-light mt-auto">
        <div className="container-fluid px-4">
          <div className="d-flex align-items-center justify-content-between small">
            <div className="text-muted">
              Copyright &copy; 2024 Praxep Foundation - All Rights Reserved.
            </div>
          </div>
        </div>
      </footer>
      </>
  );
}
